import Paper from "@mui/material/Paper";
import ViewAwareSlider from "../Shared/ViewAwareSlider";

const slider_ = (theme) => ({
  height: "30vh",
  boxShadow: "none",
  display: "flex",
  justifyContent: "center",
  backgroundColor: "whitesmoke",
  [theme.breakpoints.down("sm")]: {
    display: "none !important",
  },
});

export default function ZoomSlider({ zoom, handleChange }) {
  return (
    <Paper sx={slider_}>
      <ViewAwareSlider
        orientation="vertical"
        value={zoom}
        onChange={handleChange}
        min={4}
        max={24}
        step={0.05}
        size="small"
        label="Zoom"
      />
    </Paper>
  );
}
